import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        requiresAuth: false
      },
      component: Home
    },

    {
      path: "/bucket",
      name: 'bucket',
      meta: {
        requiresAuth: false,
      },
      component: () => import(/* webpackChunkName: "admin" */ '@/views/ManageBucket.vue')
    },

    {
      path: "/searchUser",
      name: 'searchUser',
      meta: {
        requiresAuth: false,
      },
      component: () => import(/* webpackChunkName: "admin" */ '@/views/SearchUsers.vue')
    },

    {
      path: "/bucketList",
      name: 'bucketList',
      meta: {
        requiresAuth: false,
      },
      component: () => import(/* webpackChunkName: "admin" */ '@/views/BucketList.vue')
    },

    {
      path: "/transcribeDetails/:id",
      name: 'transcribeDetails',
      meta: {
        requiresAuth: false,
      },
      component: () => import(/* webpackChunkName: "admin" */ '@/views/TranscribeDetails.vue'),
      props: true
    },    

    {
      path: "/users/:id",
      name: 'users',
      meta: {
        requiresAuth: false,
      },
      component: () => import(/* webpackChunkName: "admin" */ '@/views/ManageUsers.vue'),
      props: true
    },

    {
      path: '/unauthorized',
      name: 'unauthorized',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/Unauthorized.vue')
    },

    {
      path: '/normalize',
      name: 'normalize',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/Normalize.vue')
    },

    {
      path: '/ieNotification',
      name: 'ieNotification',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/IeNotification.vue')
    },

    {
      path: '/eventReport',
      name: 'eventReport',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/EventReport.vue')
    },

    {
      path: '/errorReport',
      name: 'errorReportt',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/ErrorReport.vue')
    },

    {
      path: '*', 
      component: Home
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(navigator.userAgent.match(/msie|trident/i) && to.name !== "ieNotification") {
    router.push("ieNotification")
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak.authenticated) {
      if (to.meta.authRoles) {
        let hasRole = false
        for (var i = 0; i < to.meta.authRoles.length; i++) {
          if (router.app.$keycloak.hasResourceRole(to.meta.authRoles[i])) {
            hasRole = true;
          }
        }
        if (hasRole) {
          next()
        } else {
          router.push('unauthorized') 
        }
      } else {
        next();
      }
    } else {
      const loginUrl = router.app.$keycloak.createLoginUrl()
      window.location.replace(loginUrl)
    }
  } else {
    next()
  }
})

export default router